import React from "react"
import {
  CardWithHeader,
  ImportantMessage,
  LockIcon,
  ThreadCard,
  FormView, isNsContent,
  FlaggedMessage,
  PostWrapper,
  useAccessContext,
  AppComponentsContextProvider,
  InfoMessage,
  ShowNotificationsPanel,
  EventParticipantsList,
  ReferencesCard,
} from "lib-core"

import { EventStreamingUrl } from "events/EventStreamingUrl"
import { EventTitle } from "events/EventTitle"

import PostComplete from "./PostComplete/PostComplete"
import ContentCard, { videoIndex } from "./content/ContentCard"
import TagsCard from "./tags/TagsCard"
import ResponsesCard from "post-responses/ResponsesCard"


import EventDate from "events/EventDate"

import { ResponsesWhenStreamedVideo } from "events/StreamResponses"

import { useSelector } from "react-redux"

import { EventToolbar } from "events/EventToolbar"
import { ReactFC } from "types"
import { Post } from "posts/posts.types"

import { EventImage } from "events/EventImage"

import Link from 'pages/profile/posts/view/content/Link'


import styled from "styled-components"


import { RespondToPost } from "post-responses/RespondToPost"

import { usePostLoaded, useRefreshResponses } from 'posts/posts.selectors'




const Wrapper = styled.div`
  display: flex;
  min-height: 100%;
  min-width: 100vw;
  background-color:#F6F7F8;
  padding: 30px;
  @media (max-width: 768px) {
    padding: 15px;
  }
`

const MainPanel = styled.div`
  flex: auto;
  padding-bottom: 15em;
  position: relative;
  padding: 0 20px;
  overflow: auto;
  `

const PostViewTitle: ReactFC<{ post: Post }> = ({ post }) => {
  if (!post.event || isNsContent(post.content)) {
    return null
  }

  return (
    <PostWrapper post={post}>
      <EventTitle post={post} />
    </PostWrapper>
  )
}

const ViewPublishedPost: ReactFC<{ post: Post }> = ({ post: post }) => {
  const { isAdmin } = useAccessContext()

  const session = useSelector((state) => state.session)

  const username = session?.value?.username

  if (!post || post.unpublished) {
    return (
      <CardWithHeader title="post.unpublished" icon={LockIcon}>
        <ImportantMessage i18nKey="post.unpublished_description" />
      </CardWithHeader>
    )
  }

  if (post.type === "asset") {
    return (<FormView value={post.form?.data} tags={post.tags} />)
  }

  return (
    <AppComponentsContextProvider usePostLoaded={usePostLoaded} useRefreshResponses={useRefreshResponses} Link={Link}>
      <Wrapper className="postWrapper">
        <MainPanel>
          <FlaggedMessage />
          <InfoMessage />
          <ThreadCard
            post={post}
          />
          <PostViewTitle post={post} />

          <EventStreamingUrl post={post} />
          <EventImage post={post} />
          <ResponsesWhenStreamedVideo post={post} />

          <ContentCard post={post} eventFilters />
          <EventToolbar isAdmin={isAdmin} post={post} username={username} />
          <EventDate post={post} />
          <EventParticipantsList post={post} />

          <PostComplete />

          <TagsCard />
          <ReferencesCard post={post} />
          <PostResponses post={post} />
        </MainPanel>
        <ShowNotificationsPanel />
      </Wrapper>
    </AppComponentsContextProvider>
  )
}

const PostResponses: ReactFC<{ post: Post }> = ({ post }) => {
  if (post.event && !isNsContent(post.content)) {
    const index = videoIndex(post.content)
    if (index !== -1) {
      return null
    }
  }

  return (
    <ResponsesCard >
      <RespondToPost />
    </ResponsesCard>
  )
}

export default ViewPublishedPost

